import type {API_ObjectAttributesType} from "../../types-telematics";
import type {RelationType} from "../../types-analytics";
import {_} from "../../Lang.class.js";
import {smartRounding} from "../../tools/smartRounding";

class FilterLocale {

    getDescriptionForRelation(relation: RelationType, fieldType: API_ObjectAttributesType): string {
        let description: string = '';
        if (typeof fieldType === 'undefined') {
            console.warn('Filter, getDescriptionForRelation, fieldType is undefined', relation, fieldType);
            return '';
        }
        switch (relation.type) {
            case 'value': {
                description = this.getDescriptionForRelationValue(relation, fieldType);
                break;
            }
            case 'period': {
                // description = 'PERIOD-RELATION' + fieldType.filter_str;
                description = this.getDescriptionForRelationPeriod(relation, fieldType);
                break;
            }
            default: {
                alert('Filter, getDescriptionForRelation, Unknown relation type: ' + relation.type);
            }
        }
        // console.log('getDescriptionForRelation', relation, fieldType, description);
        return description;
    }

    getDescriptionForRelationPeriod(relation: RelationType, fieldType: API_ObjectAttributesType): string {
        let description = '';
        if (typeof fieldType === 'undefined') {
            console.warn('Filter, getDescriptionForRelationPeriod, fieldType is undefined', relation, fieldType);
            return '';
        }
        description = fieldType.filter_str.substring(0, fieldType.filter_str.indexOf('%')).trim();

        description += ` ${_('w')} ${relation.base_period}`;

        switch (relation.c) {
            case 'inc,<=': {
                // locativeForm = (new FilterLocale()).getLocativeString(fieldType.filter_str, 'zwiększonej', 'zwiększoną');
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zwiększoną poniżej', 'zwiększonym poniżej'))}`;
                break;
            }
            case 'inc,>=': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zwiększoną powyżej', 'zwiększonym powyżej'))}`;
                break;
            }
            case 'dec,<=': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zmniejszoną poniżej', 'zmniejszonym poniżej'))}`;
                break;
            }
            case 'dec,>=': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zmniejszoną powyżej', 'zmniejszonym powyżej'))}`;
                break;
            }
            case '>=': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zmienioną powyżej', 'zmienionym powyżej'))}`;
                break;
            }
            case '<=': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zmienioną poniżej', 'zmienionym poniżej'))}`;
                break;
            }
            case '><': {
                description += ` ${_((new FilterLocale()).getStringSex(fieldType.filter_str, 'zmienioną między', 'zmienionym między'))}`;
                break;
            }
            default:
                alert('Filter, getDescriptionForRelationPeriod, Unknown relation.c: ' + relation.c);
        }

        let [r0, r1] = (new smartRounding()).getRoundedValuesWithTheSameUnit(
            [parseFloat(relation.v[0] as string), parseFloat(relation.v[1] as string)],
            relation.unit,
            { convert_nicer:true }
        )

        if (relation.v.length == 1) {
            description += ' ' + [r0.rounded_value,r0.rounded_title].filter(c => c !== '').join(' ').replace('  ', ' ') + r0.rounded_unit;
        } else if (relation.v.length > 1) {
            description += ' ' + [r0.rounded_value,_('i'),r1.rounded_value,r1.rounded_title].filter(c => c !== '').join(' ').replace('  ', ' ') + r0.rounded_unit;
            // description += ' a ' + relation.v[1] + relation.unit;
        }

        description += ` (${_('w porównaniu do')} %s)`.replace('%s', relation.second_period);

        return description;
    }


    getDescriptionForRelationValue(relation: RelationType, fieldType: API_ObjectAttributesType): string {
        let description = '';
        description = fieldType.filter_str.substring(0, fieldType.filter_str.indexOf('%')).trim();
        description += ` ${_('w')} ${relation.base_period}`;

        let [r0, r1] = (new smartRounding()).getRoundedValuesWithTheSameUnit(
            [parseFloat(relation.v[0] as string), parseFloat(relation.v[1] as string)],
            relation.unit,
            { convert_nicer:true }
        )
        // let v0 = (new smartRounding()).getRoundedValues(parseFloat(relation.v[0] as string), relation.unit, { convert_nicer:true })[0] ?? null;
        // let v1 = (new smartRounding()).getRoundedValues(parseFloat(relation.v[1] as string), relation.unit, { convert_nicer:true })[0] ?? null;

        switch (relation.c) {
            case '<=': {
                description += ` ${_('poniżej')} ${r0.rounded_value} ${r0.rounded_title} ${r0.rounded_unit} `;
                break;
            }
            case '>=': {
                description += ` ${_('powyżej')} ${r0.rounded_value} ${r0.rounded_title} ${r0.rounded_unit} `;
                break;
            }
            case '==': {
                description += ` ${_('równym')} ${r0.rounded_value} ${r0.rounded_title} ${r0.rounded_unit} `;
                break;
            }
            case '><': {
                if (fieldType.data_type==='date') {
                    description += ` ${r0.rounded_value} - ${r1.rounded_value} ${r1.rounded_title} ${r1.rounded_unit} `;
                } else {
                    description += ` ${_('pomiędzy')} ${r0.rounded_value} ${_('i')} ${r1.rounded_value} ${r1.rounded_title} ${r1.rounded_unit} `;
                }
                break;
            }
            default:
                alert('Filter, getDescriptionForRelationValue, Unknown relation.c: ' + relation.c);
        }


        return description;
    }


    getDecodeSex(value: string | number | null): 'female' | 'male' {
        // return 'female' if any word in the string ending with 'a' or 'e', otherwise return male
        if (value === null) {
            return 'male';
        }
        const femaleWordRegex = ['.+ą$','.+ę$','z\sl\.\s','powierzchni'];
        const words = value.toString().trim().split(' ');
        for (const word of words) {
            // for word check if any regex from femaleWordRegex matches
            for (const regex of femaleWordRegex) {
                let regexObj = new RegExp(regex, 'ig');
                if (regexObj.test(word.trim())) {
                    return 'female';
                }
            }
        }
        return 'male';
    }

    isLocative(value: string | number | null): boolean {
        if (value === null) {
            return false;
        }
        const locativeRegex = ['o\s.+'];
            // for word check if any regex from femaleWordRegex matches
            for (const regex of locativeRegex) {
                let regexObj = new RegExp(regex, 'ig');
                if (regexObj.test(String(value).trim())) {
                    return true;
                }
            }
        return false;
    }


    getStringSex(value: string | number | null, femaleString: string, maleString: string): string {
        switch (this.getDecodeSex(value)) {
            case 'female': {
                return femaleString;
            }
            case 'male': {
                return maleString;
            }
            default:
                return maleString;
        }
    }

}

export default FilterLocale;
